import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  isDevMode,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { MatButton } from '@angular/material/button';
import { of, Subject } from 'rxjs';
import { Notification } from 'app/layout/common/notifications/notifications.types';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { WebSocketConfigService, WebSocketRequest } from '../../../core/web-socket/web-socket-config.service';
import { DataStoreService, OrganisationService, sendMessage, SnackBarService, UserService } from '../../../core';
import { catchError, map } from 'rxjs/operators';

declare const webNotification;


@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  exportAs: 'notifications'
})
export class NotificationsComponent implements OnInit, OnDestroy {
  unreadCount: number;
  public dateFormat = 'MMM d, y hh:mm a';
  pageNumber = 1;
  totalRecords = 0;
  notificationAccessKey = 'notification';
  function;
  count = 0;
  private _overlayRef: OverlayRef;
  private _unsubscribeAll: Subject<any>;

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------
  @ViewChild('notificationsOrigin')
  private _notificationsOrigin: MatButton;
  /* get notifications(): Notification[] {

   }*/
  @ViewChild('notificationsPanel')
  private _notificationsPanel: TemplateRef<any>;

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * Constructor
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {NotificationsService} _notificationsService
   * @param {Overlay} _overlay
   * @param {ViewContainerRef} _viewContainerRef
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    public _notificationsService: NotificationsService,
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef,
    private webSocketCofingService: WebSocketConfigService,
    private userService: UserService, public store: DataStoreService,
    public organisationService: OrganisationService,
    private snackBarService: SnackBarService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // Set the defaults
    this.unreadCount = 0;
    // this.onClick();
  }

  // Private
  private _notifications: Notification[] = [];

  /**
   * Setter & getter for data
   */
  set notifications(value: Notification[]) {
    // Store the value
    this._notificationsService.store(value || []);
  }

  /**
   * On init
   */
  ngOnInit(): void {
    setTimeout(() => {
      this.getNotificationRequest();
    });

    this.recieveNotifications();
    this._notificationsService.notifications$.subscribe((res) => {
      this._notifications = res || [];
    });

  }

  recieveNotifications(): void {
    let apiUrl = `/receive/${this.userService.getUserProperty('crmId')}`;
    this.webSocketCofingService.connect(() => {
      if (!this.webSocketCofingService.stompClient) {
        return;
      }
      this.webSocketCofingService.stompClient.subscribe(apiUrl, (response) => {
        let recievedResponse = JSON.parse((response.body));
        /* if (!recievedResponse?.response) {
           this.toaster.open(recievedResponse.message, 'error');
         }*/
        switch (recievedResponse?.response?.action) {
          case 'NOTIFICATION': {
            let newNotification = recievedResponse.response.result;
            if (!isDevMode()) {
              this.showBrowserPopup(newNotification);
              this.showToaster(newNotification);
            }
            this.notifications = [...[recievedResponse.response.result], ...this._notifications];

            // Calculate the unread count
            /* this._calculateUnreadCount();

             // Mark for check
             this._changeDetectorRef.markForCheck();*/
            break;
          }
          case 'GET_NOTIFICATION': {
            let arr = [...this._notifications];
            let ids = arr.map(it => it.id);
            recievedResponse.response.result.list.forEach((it) => {
              if (!ids.includes(it.id)) {
                arr.push(it);
              }
            });
            this.notifications = [...arr];
            this.totalRecords = recievedResponse.response.result.totalRecords;
            this.unreadCount = recievedResponse.response.result.unread;
            /* // Calculate the unread count
             this._calculateUnreadCount();

             // Mark for check
             this._changeDetectorRef.markForCheck();
             console.log(recievedResponse);*/
            break;
          }
        }
      }, this.webSocketCofingService.getHeaderOptions());
    }, (err) => {
      console.log(err);
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  getNotificationRequest(): void {
    const request: WebSocketRequest = {
      type: 'NOTIFICATION',
      action: 'GET_NOTIFICATION',
      pageNumber: this.pageNumber,
      pageSize: 30,
      sort: [{
        direction: 'DESC',
        property: 'createdOn'
      }]

    };
    this.webSocketCofingService.sendRequest(sendMessage, request)
      .pipe(
        map((resp) => {
          return resp;
        }),
        catchError((error: Error) => {
          return of(error);
        })).subscribe((response) => {
    });
    // Subscribe to notification changes
    /*this._notificationsService.notifications$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((notifications: Notification[]) => {

        // Load the notifications
        this.notifications = notifications || [];


      });*/
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();

    // Dispose the overlay if it's still on the DOM
    if (this._overlayRef) {
      this._overlayRef.dispose();
    }
  }

  /**
   * Create route from given link
   */
  createRouteFromLink(link): string[] {
    // Split the link and add a leading slash
    const route = link.split('/');
    route.unshift('/');

    // Return the route
    return route;
  }

  /**
   * Open the notifications panel
   */
  openPanel(): void {
    // Create the overlay
    this._overlayRef = this._overlay.create({
      hasBackdrop: true,
      backdropClass: '',
      scrollStrategy: this._overlay.scrollStrategies.block(),
      positionStrategy: this._overlay.position()
        .flexibleConnectedTo(this._notificationsOrigin._elementRef.nativeElement)
        .withFlexibleDimensions()
        .withViewportMargin(16)
        .withLockedPosition()
        .withPositions([
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom'
          }
        ])
    });

    // Create a portal from the template
    const templatePortal = new TemplatePortal(this._notificationsPanel, this._viewContainerRef);

    // Attach the portal to the overlay
    this._overlayRef.attach(templatePortal);

    // Subscribe to the backdrop click
    this._overlayRef.backdropClick().subscribe(() => {

      // If overlay exists and attached...
      if (this._overlayRef && this._overlayRef.hasAttached()) {
        // Detach it
        this._overlayRef.detach();
      }

      // If template portal exists and attached...
      if (templatePortal && templatePortal.isAttached) {
        // Detach it
        templatePortal.detach();
      }
    });
  }

  /**
   * Mark all notifications as read
   */
  markAllAsRead(): void {
    // Mark all as read
    this._notificationsService.markAllAsRead().subscribe();
  }

  /**
   * Toggle read status of the given notification
   */
  toggleRead(notification): void {
    if (notification.read) {
      notification.read = !notification.read;
      this._notificationsService.markAsUnRead(notification.id, notification).subscribe();
    } else {
      notification.read = !notification.read;

      // Update the notification
      this._notificationsService.markAsRead(notification.id, notification).subscribe();
    }
    // Toggle the read status

  }

  /**
   * Delete the given notification
   */
  delete(notification): void {
    // Delete the notification
    this._notificationsService.delete(notification.id).subscribe();
  }

  onScroll(event?) {
    // console.log('scroll', event)
    if (this._notifications?.length < this.totalRecords) {
      this.pageNumber = this.pageNumber + 1;
      this.getNotificationRequest();
    }
  }

  showBrowserPopup(noti) {
    webNotification.showNotification(noti.title, {
      body: noti.content.replace('\n', ''),
      icon: 'assets/images/logo/hitech-logo.png',
      onClick: function onNotificationClicked() {
        // console.log('Notification clicked.');
      },
      autoClose: 10000 //auto close the notification after 4 seconds (you can manually close it via hide function)
    }, (error, hide) => {
      //console.log(error);
      if (error) {
        if (this.count < 1) {
          window.alert('Unable to show notification: ' + error.message);
          this.count++;
        }
      } else {
        //   console.log('Notification Shown.');

        setTimeout(function hideNotification() {
          //   console.log('Hiding notification....');
          hide(); //manually close the notification (you can skip this if you use the autoClose option)
        }, 5000);
      }
    });
  }

  showToaster(noti): void {
    this.snackBarService.openWithConfig(noti.content, 'info', 'OK',
      {
        horizontalPosition: 'end',
        verticalPosition: 'top',
        announcementMessage: 'New Version Available.'
      });
  }

  /**
   * Calculate the unread count
   *
   * @private
   */
  private _calculateUnreadCount(): void {
    let count = 0;

    if (this.notifications && this.notifications.length) {
      count = this.notifications.filter((notification) => notification.read === false).length;
    }

    this.unreadCount = count;
  }
}
